import { useEffect, useState } from "react";

const usePokemons = () => {
  const [pokemonsUtils, setPokemonsUtils] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null); // Para manejar errores

  const limitPokemons = 1200; // Tengo que asegurar de que este valor no cambie

  useEffect(() => {
    const retrievePokemons = async () => {
      setError(null); // Limpiar cualquier error previo
      setIsLoading(true);
      try {
        const response = await fetch(
          `https://pokeapi.co/api/v2/pokemon?limit=${limitPokemons}`
        );
        if (!response.ok) throw new Error("Failed to fetch pokemons.");
        const data = await response.json();
        setPokemonsUtils(data.results);

        setIsLoading(false);
      } catch (error) {
        setError(error.message); // Establecer el mensaje de error
        console.error("Error fetching data", error);
      } finally {
        setIsLoading(false);
        console.log(error);
      }
    };

    retrievePokemons();
  }, []); // No necesitas `limitPokemons` como dependencia ya que no cambia.

  // if (isLoading) {
  //   return (
  //     <div>
  //       <p>
  //         (｡•́‿•̀｡)💭⌛️ “Wait a little, a little bit more... ¡It's almost done!”
  //         ⏳💕
  //       </p>
  //     </div>
  //   );
  // }

  // if (error) {
  //   return (
  //     <div>
  //       <p>Oops! Something went wrong: {error}</p>
  //     </div>
  //   );
  // }

  return { pokemonsUtils, isLoading };
};

export default usePokemons;
